import Vue from 'vue';
import input from 'ocus-styleguide/src/components/form/index.vue';
import inputIcon from 'ocus-styleguide/src/components/form/inputIcon.vue';
import check from 'ocus-styleguide/src/components/form/checkElement.vue';
import select from 'ocus-styleguide/src/components/form/select.vue';
import modal from 'ocus-styleguide/src/components/modal/index.vue';
import button from 'ocus-styleguide/src/components/button/index.vue';
import mediaPreview from 'ocus-styleguide/src/components/mediaPreview/index.vue';
import user from 'ocus-styleguide/src/components/user/index.vue';
import tooltips from 'ocus-styleguide/src/components/tooltips/customTooltip.vue';
import selectBar from 'ocus-styleguide/src/components/selectBar/index.vue';
import notification from 'ocus-styleguide/src/components/notification/index.vue';
import missionCard from 'ocus-styleguide/src/components/missionCard/index.vue';
import colors from '~~/themes/ocus/common/colors';
import card from '~~/themes/ocus/components/Card.vue';
import icon from '~~/themes/ocus/components/Icon.vue';

export default () => {
  Vue.component('OInput', input);
  Vue.component('OCheck', check);
  Vue.component('OInputIcon', inputIcon);
  Vue.component('OSelect', select);
  Vue.component('OModal', modal);
  Vue.component('OIcon', icon);
  Vue.component('OCard', card);
  Vue.component('OButton', button);
  Vue.component(
    'OAlert',
    () => import('ocus-styleguide/src/components/alert/index.vue'),
  );
  Vue.component(
    'OCalendar',
    () => import('ocus-styleguide/src/components/calendar/index.vue'),
  );
  Vue.component(
    'OCalendarTooltip',
    () => import('ocus-styleguide/src/components/calendar/tooltip.vue'),
  );
  Vue.component(
    'ODateElement',
    () => import('ocus-styleguide/src/components/dateElement/index.vue'),
  );
  Vue.component(
    'OFilterDropdown',
    () => import('ocus-styleguide/src/components/filterDropdown/index.vue'),
  );
  Vue.component(
    'OMapLoader',
    () => import('ocus-styleguide/src/components/map/loader.vue'),
  );
  Vue.component(
    'OMapMarker',
    () => import('ocus-styleguide/src/components/map/marker.vue'),
  );
  Vue.component(
    'OMapPin',
    () => import('ocus-styleguide/src/components/map/pin.vue'),
  );
  Vue.component(
    'OMediaCard',
    () => import('ocus-styleguide/src/components/mediaCard/index.vue'),
  );
  Vue.component(
    'OMediaPreview',
    mediaPreview,
  );
  Vue.component(
    'OMissionCard',
    missionCard,
  );
  Vue.component(
    'ONotation',
    () => import('ocus-styleguide/src/components/notation/index.vue'),
  );
  Vue.component(
    'ONotification',
    notification,
  );
  Vue.component(
    'ONotificationIcon',
    () => import('ocus-styleguide/src/components/notification/icon.vue'),
  );
  Vue.component(
    'ONotificationList',
    () => import('ocus-styleguide/src/components/notification/list.vue'),
  );
  Vue.component(
    'ONotificationMenu',
    () => import('ocus-styleguide/src/components/notification/menu.vue'),
  );
  Vue.component(
    'OProgressBar',
    () => import('ocus-styleguide/src/components/progressBar/index.vue'),
  );
  Vue.component(
    'ORangeSlider',
    () => import('ocus-styleguide/src/components/rangeSlider/index.vue'),
  );
  Vue.component(
    'OSelectBar',
    selectBar,
  );
  Vue.component(
    'OStep',
    () => import('ocus-styleguide/src/components/step/index.vue'),
  );
  Vue.component(
    'OTableInvoice',
    () => import('ocus-styleguide/src/components/table/invoice.vue'),
  );
  Vue.component(
    'OTableMission',
    () => import('ocus-styleguide/src/components/table/mission.vue'),
  );
  Vue.component(
    'OTag',
    () => import('ocus-styleguide/src/components/tag/index.vue'),
  );
  Vue.component(
    'OTodo',
    () => import('ocus-styleguide/src/components/todo/index.vue'),
  );
  Vue.component(
    'OTooltip',
    () => import('ocus-styleguide/src/components/tooltips/index.vue'),
  );
  Vue.component(
    'OCustomTooltips',
    tooltips,
  );
  Vue.component(
    'OTransitionExpand',
    () => import('ocus-styleguide/src/components/transition/expand.vue'),
  );
  Vue.component(
    'OUpload',
    () => import('ocus-styleguide/src/components/upload/index.vue'),
  );
  Vue.component(
    'OUser',
    user,
  );
  Vue.component(
    'OWarning',
    () => import('ocus-styleguide/src/components/warning/index.vue'),
  );
  Vue.component(
    'OBreadcrumb',
    () => import('~~/themes/ocus/components/Breadcrumb.vue'),
  );
  Vue.component(
    'OTabFilter',
    () => import('~~/themes/ocus/components/TabFilter.vue'),
  );

  Vue.component(
    'OPagination',
    () => import('ocus-styleguide/src/components/pagination/index.vue'),
  );

  Vue.component(
    'OTimezoneDeltaTooltip',
    () => import('ocus-styleguide/src/components/timezoneDeltaTooltip/index.vue'),
  );

  Vue.component(
    'UploadIcon',
    () => import('@we-are-ocus/ocus-components/src/assets/iconComponent/UploadIcon.vue'),
  );

  Vue.component(
    'PlayCircleIcon',
    () => import('@we-are-ocus/ocus-components/src/assets/iconComponent/PlayCircleIcon.vue'),
  );
  Vue.component(
    'AlertIcon',
    () => import('@we-are-ocus/ocus-components/src/assets/iconComponent/AlertIcon.vue'),
  );
  Vue.component(
    'MoreIcon',
    () => import('@we-are-ocus/ocus-components/src/assets/iconComponent/MoreIcon.vue'),
  );
  Vue.component(
    'CameraFlatIcon',
    () => import('@we-are-ocus/ocus-components/src/assets/iconComponent/CameraFlatIcon.vue'),
  );
  Vue.component(
    'DroneIcon',
    () => import('@we-are-ocus/ocus-components/src/assets/iconComponent/DroneIcon.vue'),
  );
  Vue.component(
    'FilmIcon',
    () => import('@we-are-ocus/ocus-components/src/assets/iconComponent/FilmIcon.vue'),
  );
  Vue.component(
    'ThreeSixtyIcon',
    () => import('@we-are-ocus/ocus-components/src/assets/iconComponent/ThreeSixtyIcon.vue'),
  );
  Vue.component(
    'LongArrow',
    () => import('@we-are-ocus/ocus-components/src/assets/iconComponent/LongArrow.vue'),
  );
  Vue.prototype.$theme = {
    colors,
  };
};
